/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Component, OnInit } from '@angular/core';
import { Slider } from 'src/app/models/slider.model';
import { CommonService } from '../services/common.service';
import { ToastService } from '@kpmg-ux/ngx-tax-design-system';


@Component({
  selector: 'app-client-shell',
  templateUrl: './client-shell.component.html',
  styleUrls: ['./client-shell.component.css']
})
export class ClientShellComponent implements OnInit {
  slider: Slider = <Slider>{};

  constructor(private commonService: CommonService, private _toastrSvc: ToastService) { 
  }

  ngOnInit() {
    this.commonService.slider$.subscribe(slider => {
      if (slider) {
          this.slider = slider;
      }
    },error => {
      this._toastrSvc.showToastNotification({ text: 'An error occurred while fetching Mapping Groups.', appearance: 'error', isCloseable: true });
    });
  }
  
  closeHandler(result): void{
    this.slider = <Slider>{};
    this.commonService.slider = this.slider;
    this.commonService.slider$.next(this.commonService.slider);
  }
}
